module.exports = __webpack_public_path__ + "static/media/ShowDoMilhaoTheme.2bb4c1b0.mp3";